import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  background: #8f17d1;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export var AlertIcon = styled.div(_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.height, " - ").concat(styling.padding, " * 2) * 0.375)");
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.width, " - ").concat(styling.padding, " * 2) * 0.375)");
});
